import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

import {
    FILTER_EXPRESSIONS,
    EXPRESSION_EQUAL,
    EXPRESSION_NOT_EQUAL,
    EXPRESSION_CONTAINS,
    EXPRESSION_NOT_CONTAINS,
    EXPRESSION_GT,
    EXPRESSION_GTE,
    EXPRESSION_LT,
    EXPRESSION_LTE,
    EXPRESSION_TRUE,
    EXPRESSION_FALSE,
    EXPRESSION_BETWEEN,
    EXPRESSION_IN
} from "../../../constants/filter";

const ExpressionSelector = function (
    {
        columns,
        index,
        filter,
        query_divider = '~'
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();
    const getExpressionAsSymbol = function (expression) {
        switch (expression) {
            case EXPRESSION_EQUAL:
                return '=';
            case EXPRESSION_NOT_EQUAL:
                return '!=';
            case EXPRESSION_CONTAINS:
                return 'has';
            case EXPRESSION_NOT_CONTAINS:
                return 'has no';
            case EXPRESSION_GT:
                return '>';
            case EXPRESSION_GTE:
                return '>=';
            case EXPRESSION_LT:
                return '<';
            case EXPRESSION_LTE:
                return '<=';
            case EXPRESSION_TRUE:
                return 'TRUE';
            case EXPRESSION_FALSE:
                return 'FALSE';
            case EXPRESSION_BETWEEN:
                return 'a:b';
            case EXPRESSION_IN:
                return 'in';
            default:
                return ':';
        }
    }

    let column = columns.find(col => col.key === filter.column);
    if (column) {
        if (column.expressions.length < 1) {
            column.expressions.push(EXPRESSION_EQUAL);
            searchParams.set('expression' + query_divider + index, EXPRESSION_EQUAL);
            setSearchParams(searchParams);
        }
        if (column.expressions.length > 1) {
            return (
                <select
                    className='filter-expression-selector'
                    value={filter.expression}
                    onChange={event => {
                        searchParams.set('expression' + query_divider + index, event.target.value);
                        setSearchParams(searchParams);
                    }}
                >
                    {column.expressions.map(expression_key => {
                        return <option
                            key={expression_key}
                            value={expression_key}>{FILTER_EXPRESSIONS[expression_key]}</option>
                    })}
                </select>
            );
        }

        return (
            <div className='filter-expression-static'>{getExpressionAsSymbol(column.expressions[0])}</div>
        );
    }

    return null;
}

ExpressionSelector.propTypes = {
    index: PropTypes.number.isRequired,
    filter: PropTypes.shape({}).isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        expressions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        multiple: PropTypes.bool,
        component: PropTypes.func
    })).isRequired,
    query_divider: PropTypes.string
};

export default ExpressionSelector;
